import React from 'react';
import { standardTitle } from '../content/form0781';
import { additionalInfo } from '../../shared/components/fileInputComponent/AdditionalUploadInfo';
import {
  v3UploadFieldUI,
  v3UploadFieldSchema,
} from '../utils/fileInputComponent/uploadV3Helpers';

const strDescription = (
  <>
    <p>
      Upload copies of your service treatment records to support your claim.
    </p>
    {additionalInfo}
  </>
);

export const STR_ATTACHMENTS_TYPES = [
  { value: 'L450', label: 'STR - Dental - Photocopy' },
  { value: 'L451', label: 'STR - Medical - Photocopy' },
];

export const uiSchema = {
  'ui:title': standardTitle('Upload your service treatment records'),
  'ui:description': strDescription,
  serviceTreatmentRecordsAttachments: v3UploadFieldUI({
    attachmentTypes: STR_ATTACHMENTS_TYPES,
  }),
};

export const schema = {
  type: 'object',
  required: ['serviceTreatmentRecordsAttachments'],
  properties: {
    serviceTreatmentRecordsAttachments: v3UploadFieldSchema(),
  },
};
